import React from 'react';
import { Grid, Box } from '@mui/material';
import TransformationBase from './common/TransformationBase';
import { TransformationHeading } from './common/fields/Heading';
import { COMMON_STYLES, COMMON_VALIDATION_ALIAS, COMMON_VALIDATION_OUTPUT_COLUMN } from './common/Constants';
import { MultiSourceColumns } from './common/fields/MultiSourceColumns';
import { OutputColumnField } from './common/fields/OutputColumnField';
import TransformationArrayField from './common/fields/TransformationArrayField';

const INITIALSTATE = {
  type: 'nullif',
  alias: '',
  df: '',
  transformations: [
    {
      sourceColumns: ['', ''],
      outputColumn: '',
    },
  ],
};

const validationSchema = {
  ...COMMON_VALIDATION_ALIAS,
  ...COMMON_VALIDATION_OUTPUT_COLUMN,
  'transformations.sourceColumns': {
    validate: (value) => {
      const columnErrors = value.map((col) => (!col ? 'Column is required' : ''));
      if (value.filter(Boolean).length < 2) {
        return columnErrors.map((e, i) => (i < 2 && !value[i] ? 'At least 2 columns required' : e));
      }

      return columnErrors.some(Boolean) ? columnErrors : '';
    },
  },
};

const renderTransformationFields = ({ formField, errors, setFieldValue, disableForm, headers }) => {
  const renderField = ({ transform, index, headers, disableForm, errors }) => {
    const handleColumnChange = (colIndex, value) => {
      const newTransforms = [...formField.transformations];
      const newSourceCols = [...transform.sourceColumns];
      newSourceCols[colIndex] = value;
      newTransforms[index].sourceColumns = newSourceCols;
      setFieldValue('transformations', newTransforms);
    };

    const handleAddColumn = () => {
      const newTransforms = [...formField.transformations];
      const newSourceCols = [...transform.sourceColumns, ''];
      newTransforms[index].sourceColumns = newSourceCols;
      setFieldValue('transformations', newTransforms);
    };

    const handleRemoveColumn = (colIndex) => {
      const newTransforms = [...formField.transformations];
      const newSourceCols = transform.sourceColumns.filter((_, i) => i !== colIndex);
      newTransforms[index].sourceColumns = newSourceCols;
      setFieldValue('transformations', newTransforms);
    };
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} mb={2} />
        <Grid item xs={12}>
          <MultiSourceColumns
            sourceColumns={transform.sourceColumns}
            handleColumnChange={handleColumnChange}
            handleAddColumn={handleAddColumn}
            handleRemoveColumn={handleRemoveColumn}
            headers={headers}
            disableForm={disableForm}
            errors={errors?.sourceColumns || []}
            minColumns={2}
          />
        </Grid>
        <Grid item {...COMMON_STYLES.gridItem}>
          <OutputColumnField
            value={transform.outputColumn || ''}
            onChange={(e) => {
              const newTransforms = [...formField.transformations];
              newTransforms[index].outputColumn = e.target.value;
              setFieldValue('transformations', newTransforms);
            }}
            disabled={disableForm}
            error={!!errors?.outputColumn}
            helperText={errors?.outputColumn}
          />
        </Grid>
      </Grid>
    );
  };
  return (
    <Box sx={COMMON_STYLES.container}>
      <TransformationHeading
        title="Make Empty If Match - Return null if values match"
        disabled={disableForm}
      />
      <TransformationArrayField
        transformations={formField.transformations}
        getNewTransform={() => ({
          sourceColumns: ['', ''],
          outputColumn: '',
        })}
        setTransformations={(newTransforms) => setFieldValue('transformations', newTransforms)}
        renderField={renderField}
        errors={errors.transformations || []}
        headers={headers}
        disableForm={disableForm}
      />
    </Box>
  );
};

const NodeModal_NullIf = (props) => (
  <TransformationBase
    {...props}
    INITIALSTATE={INITIALSTATE}
    validationSchema={validationSchema}
    renderTransformationFields={renderTransformationFields}
    transformationType={INITIALSTATE.type}
    tranformationName="Make Empty If Match"
  />
);

export default NodeModal_NullIf;